<template>
  <div class="trust-bar">
    <div class="trust-inner">
      <div class="trust-item">
        <div class="trust-icon-wrap">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <div>
          <div class="trust-title">{{ t('trust.privacyTitle') }}</div>
          <div class="trust-sub">{{ t('trust.privacySub') }}</div>
        </div>
      </div>
      <div class="trust-item">
        <div class="trust-icon-wrap">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
          </svg>
        </div>
        <div>
          <div class="trust-title">{{ t('trust.verifiedTitle') }}</div>
          <div class="trust-sub">{{ t('trust.verifiedSub') }}</div>
        </div>
      </div>
      <div class="trust-item">
        <div class="trust-icon-wrap">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
          </svg>
        </div>
        <div>
          <div class="trust-title">{{ t('trust.speedTitle') }}</div>
          <div class="trust-sub">{{ t('trust.speedSub') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>
